import { schemaMixin } from '@witkac/jschema';
import formComponents from '../components/formComponents';
let components = null;
// if (window && window.Vue) {
if ((typeof window !== "undefined") && (window.Vue)) {
  //są zarejestrowane globalnie
  components = null;

} else {
  components = formComponents;
}



// import { fixSchemaDefaultOptions } from '../utils/JsonSchema';
// fixSchemaDefaultOptions.arrayItemGuidField = 'Guid';

export default {
  mixins: [schemaMixin],

  components: components,
  props: ['datamodel', 'external', 'confirmDelete', 'tabChange'],
  data() {
    let data = {};

    return {
      model: this.$props.datamodel,
      form: {
        fieldsChanged: [],
        pow: [],
        gmi: []
      }
    };
  },
  beforeMount() { },
  mounted() {
    if (this.$external.$settings && this.form.sections) {
      for (let index = 0; index < this.form.sections.length; index++) {
        const item = this.form.sections[index];

        item.unlockInfo = this.$external.$settings.unlockInfo;
        if (this.$external.$settings.tabsEnabled) {
          item.tabEnabled = this.$external.$settings.tabsEnabled.includes(index);
        }
        if (this.$external.$settings.tabsDisabled) {
          item.tabDisabled = this.$external.$settings.tabsDisabled.includes(index);
        }
      }
    }
  },
  methods: {
    prevStep(event) {
      const index = this.form.sections.findIndex(s => s.name == this.form.currentSection.name) - 1;
      if (index >= 0) {
        this.onChangeTab(event, this.form.sections[index]);
      }
    },
    nextStep(event) {
      const index = this.form.sections.findIndex(s => s.name == this.form.currentSection.name) + 1;
      if (index < this.form.sections.length) {
        this.onChangeTab(event, this.form.sections[index]);
      }
    },
    onChangeTab(event, section) {
      const errors = this.validateSection(this.form.currentSection);

      if (this.$listeners['before-change-tab']) {
        return new Promise((resolve, reject) => {
          this.$emit('before-change-tab', event, section, errors.length > 0, resolve);
        }).then(result => {
          if (result) {
            this.changeTab(section);
          }
        });
      } else {
        this.changeTab(section);
      }
    },
    changeTab(section) {
      this.form.currentSection = section;
      this.form.fieldsChanged = [];
      this.$emit('sectionchanged', section, this.form.sections);
    }
  },
  computed: {
    isLastSection: {
      get() {
        return this.form.sections[this.form.sections.length - 1].name == this.form.currentSection;
      }
    },

    isFirstSection: {
      get() {
        return this.form.sections[0].name == this.form.currentSection;
      }
    },
    disabledKonkursDates: {
      get() {
        if (this.$external.$konkurs.TerminOd && this.$external.$konkurs.TerminDo) {
          let toDate = new Date(this.$external.$konkurs.TerminOd);
          let fromDate = new Date(this.$external.$konkurs.TerminDo);

          fromDate.setHours(0);
          fromDate.setMinutes(0);
          fromDate.setSeconds(0);

          if (this.$external.$settings.maxDays && this.model.DataStart) {
            let tmp = new Date(this.model.DataStart);
            tmp.setHours(0);
            tmp.setMinutes(0);
            tmp.setSeconds(0);

            tmp.setDate(tmp.getDate() + this.$external.$settings.maxDays);
            if (tmp < fromDate) {
              fromDate = tmp;
            }
          }

          fromDate.setDate(fromDate.getDate() + 1);

          return {
            to: toDate,
            from: fromDate
          };
        }

        return undefined;
      }
    }
  },
  beforeCreate() {
    const props = this.$options.propsData;

    if (props.external) {
      this.$options.external = props.external;
      delete props.external;
    }
  },
  mounted() {
    if (window) {
      window.vm = this;
    }
  }
};
